import { ProtectedRoute } from '../../../router/protectedrouter';

import DashboardPage from "../components/dashboard/OverAllDashboard";
import MainLayout from '../../../components/layouts/MainLayoutPage';
import SingleThreatActorPage from "../components/dashboard/SingleThreatPage";
import ViewThreatActors from '../components/configurator/viewAllThreatActors';
import ViewThreatActorPage from '../components/configurator/SingleThreatPage';
import AddThreatActor from '../components/configurator/AddThreatActor';
import EditThreatActor from '../components/configurator/EditThreatActor';

import UserGuidePage from '../components/UserGuide.jsx';

const base_url="/tip";
const routes = [
    {
        path: `${base_url}`,
        children:[
            {
                path: `dashboard`,
                // path: `dashboard/over-all`,
                element: <ProtectedRoute><MainLayout> <DashboardPage /> </MainLayout></ProtectedRoute>,
                name: "dashboard",
            },
            {
                path: `view-threatactors`,
                element: <ProtectedRoute><MainLayout> <ViewThreatActors /> </MainLayout></ProtectedRoute>,
                name: "View ThreatActors",
            },
            {
                path: `view-threatactor`,
                element: <ProtectedRoute><MainLayout> <ViewThreatActorPage /> </MainLayout></ProtectedRoute>,
                name: "View ThreatActor",
            },
            {
                path: `add-threatactor`,
                element: <ProtectedRoute><MainLayout> <AddThreatActor /> </MainLayout></ProtectedRoute>,
                name: "Add ThreatActor",
            },
            {
                path: `edit-threatactor`,
                element: <ProtectedRoute><MainLayout> <EditThreatActor /> </MainLayout></ProtectedRoute>,
                name: "Edit ThreatActor",
            },
            {
                path: `threat`,
                element: <ProtectedRoute><MainLayout> <SingleThreatActorPage /> </MainLayout></ProtectedRoute>,
                name: "threat",
            },
            {
                path: `user-guide`,
                element: <ProtectedRoute><MainLayout> <UserGuidePage/> </MainLayout></ProtectedRoute>,
                name: "userguide",

            },
        ]
    },
]


export default routes;